import React,{Component} from "react";

import {
  Card,
  CardHeader,
  Button,
  ListGroup,
  ListGroupItem,
  Row,
  FormInput,
  Col,
    DatePicker,
    FormSelect
} from "shards-react";
import { Modal } from 'react-bootstrap';
import { AtomSpinner } from 'react-epic-spinners';
import firebase from '../firebase';

import { toast } from 'react-toastify';

export default class EditStudent extends Component{
  render(){

    return(
      <Modal show={this.props.show} onHide={this.props.handleClose}>
            {
            <StudentDet handleClose={this.props.handleClose} student_code={this.props.student_code}/>
            }
      </Modal>
    )
  }
}

class StudentDet extends Component{

  constructor(props) {
    super(props);
  
    this.state = {loading:false};
    this.get_data = this.get_data.bind(this);
    this.convertDate = this.convertDate.bind(this);
    this.get_updated_data=this.get_updated_data.bind(this);
  }


  get_data = ()=>{
    var that = this;
    that.setState({loading:true});
    firebase.firestore().collection('Student').doc(this.props.student_code).get().then(function(doc){
      if(doc.exists){
          var data = doc.data();
          data['dateofadmission'] = new Date(data.dateofadmission);
          data['dob'] = new Date(data.dob);
          that.setState(doc.data());
          that.setState({loading:false});
          console.log(new Date(that.state.dateofadmission));
      }
    })
  }

  convertDate(date){
      var dd = date.getDate();
      var mm = date.getMonth();
      var yyyy = date.getFullYear();

      if(dd<10){
        dd = "0"+dd;
      }
      if(mm<10){
        mm = "0"+mm;
      }

      return yyyy+"-"+mm+"-"+dd;
  }


  componentDidMount(){
      this.get_data();
  }
  get_updated_data = () =>{
    var data = {
      dateofadmission: this.state.dateofadmission,
      dob: this.state.dob,
      name:this.state.name,
      photo_url:this.state.photo_url,
      father_name:this.state.father_name,
      mother_name:this.state.mother_name,
      class:this.state.class,
      gender:this.state.gender,
      roll_no:this.state.roll_no,
      phone:this.state.phone,
      address:this.state.address,
    }

    return data;
  }

  update_data = () =>{ 
    var that = this;
    this.setState({loading:false});
    var data = this.get_updated_data();
    firebase.firestore().collection('Student').doc(this.props.student_code).update(data).then(function(){
       toast("Student Updated Successfully", {containerId: 'A'});
       that.setState({loading:false}); 
       that.props.handleClose();
    }).catch(function(Err){
        that.setState({loading:false});
    })
  }




  render(){

    return(
  <Card small className="mb-4 pt-3">
  {!this.state.loading &&
    (
  <div>
    <CardHeader className="border-bottom text-center">
      <div className="mb-3">
        <img
          className="rounded-circle"
          src={this.state.photo_url}
          alt={"No img"}
          width="150"
        />
      </div>
      <h4 className="mb-0">{this.state.name}</h4>
      <span className="text-muted d-block mb-2">{this.state.class}</span>
    </CardHeader>
    <ListGroup flush>

      <Item field="Roll No" value={this.state.roll_no} onChangeHandler={(evt)=>{this.setState({roll_no:evt.target.value})}}/>
      <DateInp field="Date of Admission" value={this.state.dateofadmission} onChangeHandler={(value)=>{this.setState({dateofadmission:this.convertDate(new Date(value))})}}/>
      <DateInp field="DOB" value={this.state.dob} onChangeHandler={(value)=>{this.setState({dob:this.convertDate(new Date(value))})}}/>
      <GenderSelect field="Gender" value={this.state.gender} onChangeHandler={(evt)=>{this.setState({gender:evt.target.value})}}/>
      <UpdateField field="Mother Name" value={this.state.mother_name} onChangeHandler={(evt)=>{this.setState({mother_name:evt.target.value})}}/>
      <UpdateField field="Father Name" value={this.state.father_name} onChangeHandler={(evt)=>{this.setState({father_name:evt.target.value})}}/>
      <UpdateField field="Phone" value={this.state.phone} onChangeHandler={(evt)=>{this.setState({phone:evt.target.value})}}/>
      <UpdateField field="Address" value={this.state.address} onChangeHandler={(evt)=>{this.setState({address:evt.target.value})}}/>


      
      <ListGroupItem>
      <Row>
       <Button   theme="danger" onClick={this.props.handleClose}>
              Cancel
        </Button> 
          <Button  style={{marginLeft: '5%'}} theme="info" onClick={this.update_data}>
              Update
        </Button> 
      </Row>
      </ListGroupItem>
    </ListGroup>
</div>
    )

  }
    
    {
                  (this.state.loading) &&
                    <div style={{margin: '10%',marginLeft: '40%'}}>
                        <AtomSpinner color="blue" />            
                    </div>
      }     
  
  </Card>
);
}

}


class UpdateField extends Component{
  render(){
    return(
        <ListGroupItem className="px-4">
        <div className="progress-wrapper">
          <Row>
          <Col md="6">
              <strong className=" d-block mb-2" style={{marginLeft: '5%',color:'blue'}}>
                  {this.props.field+":"}
              </strong>
          </Col>
          <Col md="6" className="form-group">
          <FormInput
                    id="feFirstName"
                    placeholder={this.props.value}
                    onChange={this.props.onChangeHandler}
          />
          </Col>
        </Row>    
        </div>
      </ListGroupItem>
    )
  }
}


class GenderSelect extends Component{
  render(){
    return(
        <ListGroupItem className="px-4">
        <div className="progress-wrapper">
          <Row>
          <Col md="6">
          <strong className=" d-block mb-2" style={{marginLeft: '5%',color:'blue'}}>
            {this.props.field+":"}
          </strong>
          </Col>
          <Col md="6" className="form-group">
          <FormSelect onChange={this.props.onChangeHandler}>
                        <option>{this.props.value}</option>
                        <option>Male</option>
                        <option>Female</option>
                  </FormSelect>
          </Col>
        </Row>    
        </div>
      </ListGroupItem>
    )
  }
}

class DateInp extends Component{
  render(){
    console.log((this.props.value!==undefined && this.props.value!==null)?new Date(this.props.value):"invalid date");
    console.log((this.props.value!==undefined&&this.props.value!==null) && this.props.value);
    return(
        <ListGroupItem className="px-4">
        <div className="progress-wrapper">
          <Row>
          <Col md="6">
          <strong className=" d-block mb-2" style={{marginLeft: '5%',color:'blue'}}>
            {this.props.field+":"}
          </strong>
          </Col>
          <Col md="6" className="form-group">
         { <DatePicker
                            size="ld"
                            selected={(this.props.value!==undefined && this.props.value!==null)?new Date(this.props.value):new Date()}
                            onChange={this.props.onChangeHandler}
                            placeholderText="Pick Date"
                            dropdownMode="select"
                            className="text-center"
                          />
            }
          </Col>
        </Row>    
        </div>
      </ListGroupItem>
    )
  }

}

class Item extends Component{
  render(){
    return(
      <ListGroupItem className="px-4">
        <div className="progress-wrapper">
          <Row>
          <Col md="6">
          <strong className=" d-block mb-2" style={{marginLeft: '5%',color:'blue'}}>
            {this.props.field+":"}
          </strong>
          </Col>
          <Col md="6">
          <strong className="d-block mb-2" style={{marginLeft: '2%'}}>
            {this.props.value}
          </strong>
          </Col>
        </Row>

    
        </div>
      </ListGroupItem>
    )
  }
}
